var _title, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoToken = function SvgNoToken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "select_token")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 29.8277062 0 29.8277062 29.7330614 0 29.7330614"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4EAE\\u8272\\u6A21\\u5F0F-\\u56FE\\u6807",
    transform: "translate(-861.000000, -474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "select_token",
    transform: "translate(861.000000, 474.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fillOpacity: 0.4,
    fill: "#727272",
    points: "0 30.1053723 60 30.1053723 60 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fillOpacity: 0.4,
    fill: "#ABABAB",
    points: "0.00577273198 59.8096615 59.9944493 59.8096615 59.9944493 30.0566589 0.00577273198 30.0566589"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.386351, 0.210722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4395565,14.8873019 C59.4395565,23.0977514 52.7625039,29.7538437 44.5257035,29.7538437 C36.2891251,29.7538437 29.6118504,23.0977514 29.6118504,14.8873019 C29.6118504,6.67685248 36.2891251,0.0207601735 44.5257035,0.0207601735 C52.7625039,0.0207601735 59.4395565,6.67685248 59.4395565,14.8873019",
    id: "Fill-3",
    fillOpacity: 0.4,
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.664227, 30.056216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8277062,14.8665417 C29.8277062,23.0769912 23.1506535,29.7330835 14.9138531,29.7330835 C6.67727468,29.7330835 0,23.0769912 0,14.8665417 C0,6.65609231 6.67727468,0 14.9138531,0 C23.1506535,0 29.8277062,6.65609231 29.8277062,14.8665417",
    id: "Fill-5",
    fillOpacity: 0.4,
    fill: "#727272",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.8277062,14.8665417 C29.8277062,23.0769912 23.1506535,29.7330835 14.9138531,29.7330835 C6.67727468,29.7330835 0,23.0769912 0,14.8665417 C0,6.65609231 6.67727468,0 14.9138531,0 C23.1506535,0 29.8277062,6.65609231 29.8277062,14.8665417",
    id: "Fill-7",
    fillOpacity: 0.4,
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 30.056216)",
    fill: "#727272",
    fillOpacity: 0.4,
    id: "Fill-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8277062,14.8665417 C29.8277062,23.0769912 23.1506535,29.7330835 14.9138531,29.7330835 C6.67727468,29.7330835 0,23.0769912 0,14.8665417 C0,6.65609231 6.67727468,0 14.9138531,0 C23.1506535,0 29.8277062,6.65609231 29.8277062,14.8665417"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.9178866,14.8873019 C51.9178866,18.9570042 48.6083349,22.2560569 44.5256813,22.2560569 C40.4432496,22.2560569 37.1334759,18.9570042 37.1334759,14.8873019 C37.1334759,10.8175997 40.4432496,7.51854694 44.5256813,7.51854694 C48.6083349,7.51854694 51.9178866,10.8175997 51.9178866,14.8873019",
    id: "Fill-11",
    fill: "#444446"
  }))))))));
};

export { SvgNoToken as ReactComponent };
export default __webpack_public_path__ + "776b9c6920494124ee3034bc26cf6721.svg";